<template>
  
</template>

<script>
export default {
  data() {
    return {
      qty: 1
    }
  },
  props: ['product_id'],
  mounted() {
    console.log(props.product_id)
  }
}
</script>